import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import { Textarea } from '../../ui/textarea';
import { Loader2, Trophy } from 'lucide-react';

/**
 * Set the final result for a game (win/loss/tied/no_game/postponed) + optional
 * notes. Extracted from TournamentGames.js in iter277.
 */
const GameResultDialog = ({
  open,
  onOpenChange,
  selectedGame,
  gameResult,
  setGameResult,
  gameResultNotes,
  setGameResultNotes,
  onSave,
  submitting,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Trophy className="h-5 w-5 text-blue-600" />
            Set Game Result
          </DialogTitle>
          <DialogDescription>
            {selectedGame?.team_name || 'TBD'} vs {selectedGame?.opponent_team} • {selectedGame?.game_date}
          </DialogDescription>
        </DialogHeader>

        <div className="py-4 space-y-4">
          <div>
            <Label className="text-sm font-medium mb-2 block">Result</Label>
            <div className="grid grid-cols-3 gap-2">
              {[
                { value: 'win', label: 'Win', color: 'bg-green-100 hover:bg-green-200 border-green-300 text-green-700' },
                { value: 'loss', label: 'Loss', color: 'bg-red-100 hover:bg-red-200 border-red-300 text-red-700' },
                { value: 'tied', label: 'Tied', color: 'bg-yellow-100 hover:bg-yellow-200 border-yellow-300 text-yellow-700' },
              ].map(opt => (
                <Button
                  key={opt.value}
                  variant="outline"
                  className={`${gameResult === opt.value ? opt.color + ' border-2' : ''}`}
                  onClick={() => setGameResult(opt.value)}
                >
                  {opt.label}
                </Button>
              ))}
            </div>
            <div className="grid grid-cols-2 gap-2 mt-2">
              {[
                { value: 'no_game', label: 'No Game', color: 'bg-slate-100 hover:bg-slate-200 border-slate-300 text-slate-700' },
                { value: 'postponed', label: 'Postponed', color: 'bg-orange-100 hover:bg-orange-200 border-orange-300 text-orange-700' },
              ].map(opt => (
                <Button
                  key={opt.value}
                  variant="outline"
                  className={`${gameResult === opt.value ? opt.color + ' border-2' : ''}`}
                  onClick={() => setGameResult(opt.value)}
                >
                  {opt.label}
                </Button>
              ))}
            </div>
            {gameResult && (
              <Button
                variant="ghost"
                size="sm"
                className="mt-2 text-slate-500"
                onClick={() => setGameResult('')}
              >
                Clear selection
              </Button>
            )}
          </div>

          <div>
            <Label htmlFor="result-notes" className="text-sm font-medium">Notes (optional)</Label>
            <Textarea
              id="result-notes"
              value={gameResultNotes}
              onChange={(e) => setGameResultNotes(e.target.value)}
              placeholder="Score, highlights, or other notes..."
              className="mt-1"
              rows={2}
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={onSave}
            disabled={submitting}
          >
            {submitting ? (
              <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Saving...</>
            ) : (
              'Save Result'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default GameResultDialog;
